// StatusDropdownUikit.tsx
import React, { useRef } from 'react';
import { svgIcons } from '../UI/SvgIcons';
import { formatStatus } from '@/utility/helper';
import { usePermissions } from '@/hooks/usePermissions';
const { DownArrow } = svgIcons;

export type Option = {
  value: string;
  label?: string;
  textClass?: string;
  bgClass?: string;
};

type ColorClasses = { textClass?: string; bgClass?: string };

type Props = {
  canEditVal?: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  getColorClasses?: (status: string) => ColorClasses;
  buttonClassName?: string;
  dropdownClassName?: string;
  dropdownPos?: string;
  id?: string;
  renderRightIcon?: React.ReactNode;
};

export default function StatusDropdown({
  canEditVal,
  value,
  options,
  onChange,
  // getColorClasses,
  // buttonClassName = '',
  // dropdownClassName = '',
  // dropdownPos = 'pos: bottom-right',
  // id,
  // renderRightIcon,
}: Props) {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const { canEdit } = usePermissions();
  // const resolved: ColorClasses = getColorClasses
  //   ? getColorClasses(value)
  //   : (options.find((o) => o.value === value) ??
  //     ({ textClass: 'text-gray-700', bgClass: 'bg-gray-400' } as Option));

  function handleSelect(v: string) {
    onChange(v);

    try {
      const UIkit = (window as any).UIkit;
      if (UIkit && rootRef.current) {
        const dropdownEl = rootRef.current.querySelector('[data-uk-dropdown]');
        if (dropdownEl) {
          const instance = UIkit.dropdown(dropdownEl);
          instance?.hide?.();
        }
      }
    } catch {}
  }
  const selected = options.find((opt) => opt.value === value);
  return (
    <>
      <div ref={rootRef}>
        <button
          className={`text-sm capitalize ${selected?.textClass} leading-normal flex items-center gap-2`}
        >
          {selected?.bgClass && (
            <div
              className={`${selected?.bgClass} rounded-full min-w-2.5 h-2.5`}
            ></div>
          )}
          {formatStatus(value)}
          {options.length > 0 && canEditVal && canEdit(canEditVal) && (
            <span className="min-w-fit">{DownArrow}</span>
          )}
        </button>

        {options.length > 0 && canEditVal && canEdit(canEditVal) && (
          <div className="rounded-lg" data-uk-dropdown="pos: bottom-right">
            <ul className="uk-nav uk-dropdown-nav p-2 text-base space-y-1">
              {options.map((opt) => (
                <li key={opt.value}>
                  <button
                    type="button"
                    onClick={() => {
                      if (opt.value != value) {
                        handleSelect(opt.value);
                      }
                    }}
                    className={`flex items-center text-sm capitalize gap-1.5 p-3 w-full rounded-lg ${opt.value == value ? 'bg-primary-light' : 'hover:bg-primary-light'} `}
                  >
                    <span
                      className={`w-2.5 h-2.5 rounded-full ${opt.bgClass ?? ''} inline-block`}
                    />
                    <span className={`${opt.textClass ?? 'text-black'}`}>
                      {opt.label ?? opt.value}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {/* <div
        ref={rootRef}
        className="uk-inline"
        id={id}
        data-uk-dropdown={dropdownPos}
      >
        <button
          type="button"
          className={`text-sm capitalize ${resolved.textClass} leading-normal flex items-center gap-2 px-3 py-1 rounded ${buttonClassName}`}
        >
          <span
            className={`w-2.5 h-2.5 rounded-full ${resolved.bgClass} inline-block`}
          />
          <span>{value}</span>
          {renderRightIcon ?? DownArrow}
        </button>

        <div className={`rounded-lg ${dropdownClassName}`}>
          <ul className="uk-nav uk-dropdown-nav p-2 text-base">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  type="button"
                  onClick={() => handleSelect(opt.value)}
                  className={`flex items-center text-sm capitalize gap-1.5 px-3 py-1 w-full rounded-lg hover:bg-primary-light`}
                >
                  <span
                    className={`w-2.5 h-2.5 rounded-full ${opt.bgClass ?? ''} inline-block`}
                  />
                  <span className={`${opt.textClass ?? 'text-black'}`}>
                    {opt.label ?? opt.value}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
    </>
  );
}
